import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/video/spinner02.gif'
import _imports_1 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-64c13eda"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#F3F3F3"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-video" }
const _hoisted_4 = { class: "p-video-inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-video-heading-1" }, "転職活動ノウハウ動画", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "note-video-list" }, " ※マイナビAGENTは2025年12月17日付でサービス名を「マイナビ転職AGENT」へ変更いたしました。 ", -1))
const _hoisted_7 = { class: "p-video-list" }
const _hoisted_8 = { class: "p-video-list__image" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  src: _imports_0,
  alt: "",
  width: "325",
  height: "188"
}
const _hoisted_11 = { class: "p-video-list__body" }
const _hoisted_12 = { class: "p-video-list__title" }
const _hoisted_13 = { class: "p-video-list__text" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "詳細を見る", -1))
const _hoisted_15 = { class: "l-wrapper_nav" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]

import { getVideoKnowHowListService, KnowHowDetailResponse, loadVideoThumbnailService } from '@/api/services/mstMypageVideoKnowHowService';
import Loading from '@/components/Loading.vue';
import { onActivated, ref } from 'vue';
import { RouterLink, useRoute } from 'vue-router';
import { domHelperUtils } from '@/utils/domHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoListView',
  setup(__props) {

const videoList = ref<Array<KnowHowDetailResponse>>([]);
const isLoading = ref(false);
const isJobListLoaded = ref(false);

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

const route = useRoute();
onActivated(async() => {
  isLoading.value = true;

  // Keep the page state when has back event
  if(route.meta.isBack && isJobListLoaded.value) {
    isLoading.value = false;
    return;
  }

  const fetchedData = await getVideoKnowHowListService();
  if (fetchedData && fetchedData.length) {
    videoList.value = [...fetchedData];
    videoList.value.forEach(async (video) => {
      let imgUri = await loadVideoThumbnailService(video.vimeoId);
      if (!imgUri) {
        imgUri = (new URL('../../assets/img/video/nonImg.png', import.meta.url)).href;
      }
      video.thumbnailUrl = imgUri;
    });
  }
  isJobListLoaded.value = true;

  isLoading.value = false;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("main", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoList.value, (video) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: video.knowhowId,
                  class: "p-video-list__card"
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    (video.thumbnailUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: video.thumbnailUrl,
                          alt: "",
                          width: "325",
                          height: "188"
                        }, null, 8, _hoisted_9))
                      : (_openBlock(), _createElementBlock("img", _hoisted_10))
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h2", _hoisted_12, _toDisplayString(video.title), 1),
                    _createElementVNode("p", _hoisted_13, _toDisplayString(video.explanation), 1)
                  ]),
                  _createVNode(_unref(RouterLink), {
                    class: "p-video-list__link",
                    to: {name: 'p01', params: {knowhowId: video.knowhowId}}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("a", {
          class: "g-pagetop",
          href: "#",
          onClick: _withModifiers(scrollToTop, ["prevent"]),
          "aria-label": "ページトップへ戻る"
        }, _hoisted_18, 8, _hoisted_16)
      ])
    ]),
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"])
  ], 64))
}
}

})